import { getLogicalRing } from 'owa-config';

/**
 * Refers to the enum specified in SharedABT module: @webauthjs/microsoft.office.webauth.abt
 * Doc: https://www.owiki.ms/wiki/ICE_Services/WebAuth/JS/abt
 */
enum Environment {
    WorldWide = 1,
    Trailblazer = 4,
    Pathfinder = 5,
}

/**
 * TODO: return values for Trailblazer & Pathfinder instead of just WW
 * https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/54205
 */
export function getEnvironment(): Environment {
    switch (getLogicalRing()) {
        case 'WW':
        case 'FirstRelease':
        case 'Microsoft':
        case 'Dogfood':
            return Environment.WorldWide;
        default:
            return Environment.WorldWide;
    }
}
